import './UserOrganizations.css';

import B2BElementsExplorerInMemory from '../../../b2b-common/B2BElementsExplorerInMemory';
import OrganizationMemberCard from '../organization/OrganizationMemberCard';
import useMyOrganizations from '../../hooks/useMyOrganizations';

const UserOrganizations = () => {
    const { myOrganizations } = useMyOrganizations();

    if (!myOrganizations) {
        return
    }

    const sortedOrganizations = [...myOrganizations].sort((a, b) => {
        if (a.organization.organizationName < b.organization.organizationName) return -1;
        if (a.organization.organizationName > b.organization.organizationName) return 1;
        return 0;
    });

    return (
        <B2BElementsExplorerInMemory
            elementsData={{ content: sortedOrganizations }}
            className={'user-organizations'}
            ElementComponent={OrganizationMemberCard}
            elementComponentPropName={'organizationMember'}
            currentPage={1}
            numRows={4}
        />
    );
}

export default UserOrganizations;